import { IconNames } from '@blueprintjs/icons';
import {
  ItemListRenderer,
  ItemPredicate,
  ItemRenderer,
} from '@blueprintjs/select';
import classNames from 'classnames';
import * as React from 'react';
import { noop } from 'vet-bones/utils';
import { SelectItem } from 'vet-bones/utils/select';

import { CollapsibleBlock } from 'src/components/CollapsibleBlock';
import { ItemQueryList } from 'src/components/select/ItemQueryList';

// currently subitems are not implemented, but the type is left
// as it was from FilterableSidebar
export type FilterableItem<T extends SelectItem = SelectItem> = SelectItem & {
  items?: T[];
  filteredItems?: T[];
};

export type FilterableCollapsibleBlockProps<ItemType extends FilterableItem> = {
  className?: string;
  header: string;
  items: ItemType[];
  itemListRenderer?: ItemListRenderer<ItemType>;
  itemPredicate?: ItemPredicate<ItemType>;
  itemRenderer?: ItemRenderer<ItemType>;
};

export const FilterableCollapsibleBlock = <ItemType extends FilterableItem>({
  className,
  header,
  items,
  itemListRenderer,
  itemPredicate,
  itemRenderer,
}: FilterableCollapsibleBlockProps<ItemType>) => {
  const QueryList = ItemQueryList.ofType<ItemType>();

  return (
    <QueryList
      collapsibleInput
      customRenderer={({ itemList }, queryInputElement) => (
        <CollapsibleBlock
          actions={queryInputElement}
          className={classNames('sd-filterable-collapsible-block', className)}
          header={header}
        >
          {itemList}
        </CollapsibleBlock>
      )}
      inputProps={{
        leftIcon: IconNames.SEARCH,
        placeholder: 'Filter',
      }}
      itemListRenderer={itemListRenderer}
      itemPredicate={itemPredicate}
      itemRenderer={itemRenderer}
      items={items}
      onSelect={noop}
    />
  );
};
